import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { selectCurrentUser } from '../features/auth/authSlice'

const ProtectedOnboardRoute = () => {
  const user = useSelector(selectCurrentUser)
  if (!user) {
    return <Navigate to="/" replace />
  }
  
  return <Outlet />
}

export default ProtectedOnboardRoute